interface Font {
  weight: number;
  size: number;
  lineHeight: number;
}

const genFont = ({ weight, size, lineHeight }: Font): string => {
  return `
      font-weight : ${weight};
      font-size : ${size}rem;
      line-height : ${lineHeight}rem;
      `;
};

export const fonts = {
  // extra-bold
  eb42: genFont({
    weight: 800,
    size: 4.2,
    lineHeight: 6.3,
  }),
  eb32: genFont({
    weight: 800,
    size: 3.2,
    lineHeight: 4.8,
  }),
  eb20: genFont({
    weight: 800,
    size: 2.0,
    lineHeight: 3.0,
  }),

  // bold
  bd36: genFont({
    weight: 700,
    size: 3.6,
    lineHeight: 4.3,
  }),
  bd32: genFont({
    weight: 700,
    size: 3.2,
    lineHeight: 4.8,
  }),
  bd26: genFont({
    weight: 700,
    size: 2.5,
    lineHeight: 3.8,
  }),
  bd24: genFont({
    weight: 700,
    size: 2.4,
    lineHeight: 3.6,
  }),
  bd20: genFont({
    weight: 700,
    size: 2.0,
    lineHeight: 3.0,
  }),
  bd18: genFont({
    weight: 700,
    size: 1.8,
    lineHeight: 2.7,
  }),
  bd16: genFont({
    weight: 700,
    size: 1.6,
    lineHeight: 2.4,
  }),
  bd15: genFont({
    weight: 700,
    size: 1.5,
    lineHeight: 2.4,
  }),
  bd12: genFont({
    weight: 700,
    size: 1.2,
    lineHeight: 1.8,
  }),

  //   semiBold
  sb26: genFont({
    weight: 600,
    size: 2.6,
    lineHeight: 4.0,
  }),
  sb14: genFont({
    weight: 600,
    size: 1.4,
    lineHeight: 2.1,
  }),
  sb12: genFont({
    weight: 600,
    size: 1.2,
    lineHeight: 1.8,
  }),

  //   medium
  md24: genFont({
    weight: 500,
    size: 2.4,
    lineHeight: 3.6,
  }),
  md20: genFont({
    weight: 500,
    size: 2,
    lineHeight: 3,
  }),
  md18: genFont({
    weight: 500,
    size: 1.8,
    lineHeight: 2.34,
  }),
  md15: genFont({
    weight: 500,
    size: 1.5,
    lineHeight: 2.3,
  }),

  //   regular
  rg24: genFont({
    weight: 400,
    size: 2.4,
    lineHeight: 3.6,
  }),
  rg16: genFont({
    weight: 400,
    size: 1.6,
    lineHeight: 2.4,
  }),
  rg15: genFont({
    weight: 400,
    size: 1.5,
    lineHeight: 2.3,
  }),
  rg14: genFont({
    weight: 400,
    size: 1.4,
    lineHeight: 2.1,
  }),
  rg13: genFont({
    weight: 400,
    size: 1.3,
    lineHeight: 2.0,
  }),
  rg12: genFont({
    weight: 400,
    size: 1.2,
    lineHeight: 1.8,
  }),
};
